import React from "react";

/**
 * HG Corporates circular stamp wordmark.
 * The source image is a 200×200 PNG with a transparent background,
 * served from /brand/logo.png. The `height` prop controls the rendered
 * size for the entire brand mark.
 */
export const Logo = ({ className = "", height = 48 }) => {
  return (
    <div
      className={`inline-flex items-center ${className}`}
      data-testid="site-logo"
      aria-label="HG Corporates"
    >
      <img
        src="/brand/logo.png"
        alt="HG Corporates"
        width={height}
        height={height}
        style={{ height, width: height }}
        className="select-none"
        draggable="false"
      />
    </div>
  );
};

export default Logo;
